import { GatewayNetworkModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/networks/models/outputs/gateway-network.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { NetworkListNameCell } from './network-list-name.cell';
import { NetworkListNameHeader } from './network-list-name.header';

export const NetworkListNameColumn: IdentifiedColumnDef<
  GatewayNetworkModel,
  GatewayNetworkModel['name']
> = {
  enableSorting: false,
  header: NetworkListNameHeader,
  cell: NetworkListNameCell,
};
